import { apiGet, apiPost, apiPatch, apiDelete } from './client';
import type { MessageTemplate } from '../types';

export async function getTemplates(companyId?: string): Promise<MessageTemplate[]> {
  const params = companyId ? `?companyId=${companyId}` : '';
  return apiGet<MessageTemplate[]>(`/message-templates${params}`);
}

export async function getTemplate(id: string): Promise<MessageTemplate> {
  return apiGet<MessageTemplate>(`/message-templates/${id}`);
}

export async function createTemplate(data: {
  name: string;
  trigger: string;
  content: string;
  departmentType?: string | null;
  companyId?: string;
}): Promise<MessageTemplate> {
  return apiPost<MessageTemplate>('/message-templates', data);
}

export async function updateTemplate(id: string, data: {
  name?: string;
  trigger?: string;
  content?: string;
  departmentType?: string | null;
  isActive?: boolean;
}): Promise<MessageTemplate> {
  return apiPatch<MessageTemplate>(`/message-templates/${id}`, data);
}

export async function deleteTemplate(id: string): Promise<void> {
  return apiDelete<void>(`/message-templates/${id}`);
}
